import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useAudit() {
  return useInfiniteQuery({
    queryKey: ['audit'],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      api.audit.list({ limit: 50, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.cursor,
  });
}
